export const OC_PRODUCTS_CATALOG_PAGE = {
  desktop: `
<div class="cui cui-grid cui-container">

  <div class="display-none display-md-block">
    <div class="cui-row">
      <div class="cui-col-lg-12 cui-skeleton-paragraph -size--small -resolution--desktop -spacing--top-40 -spacing--bottom-64">
        <div class="cui-skeleton-paragraph__content" style="width: 405px;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
    </div>

    <div class="cui-row -spacing--bottom-120">
      <div class="cui-col-lg-3 display-none display-lg-block">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 28px;"></div></div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
        
        <div class="-spacing--top-40">
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 28px;"></div></div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
        </div>
      </div>

      <div class="cui-col-lg-9">
        <div class="cui-skeleton-heading -size--large -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width:100%">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>

        <div class="display-none display-md-block display-lg-none -spacing--top-24 -spacing--bottom-24">
          <div class="display-flex">
            <div class="cui-skeleton-rectangle -spacing--right-24" style="width: 100%;"><div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div></div>
            <div class="cui-skeleton-rectangle" style="width: 100%;"><div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div></div>
          </div>
        </div>

        <div class="cui-skeleton-rectangle -is--block -spacing--top-24 -spacing--bottom-24">
          <div class="cui-skeleton__item" style="width: 160px; height: 18px;"></div>
        </div>

        <div class="display-none display-xl-block">
          <div class="catalog-product-multi-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>

            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

            </div>
          </div>

          <div class="catalog-product-multi-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>

            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

            </div>
          </div>

          <div class="catalog-product-multi-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>

            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

            </div>
          </div>

          <div class="catalog-product-multi-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>

            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

            </div>
          </div>

          <div class="catalog-product-multi-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0;">
                <div>
                  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>

            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                <div style="display: flex; gap: 16px">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="display-none display-md-block display-xl-none">
          <div class="catalog-product-multi-skeleton-md" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px;">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
              </div>

              <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-md" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px;">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
              </div>

              <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-md" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px;">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
              </div>

              <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-md" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px;">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
              </div>

              <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-md" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px;">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="padding: 16px 0;">
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <div>
                    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                    <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                  </div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
                </div>
                <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>
                  <div class="cui-skeleton-button -size--medium">
                    <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                  </div>           
                </div>
              </div>

              <div style="display: flex; justify-content: center; margin-top: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
              </div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-xl" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px; display: flex; gap: 16px">
            <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 96px; height: 96px;"></div></div>
            <div style="flex-grow: 1;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 400px; height: 28px;"></div></div>
              <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-16">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div class="cui-skeleton-rectangle -spacing--right-12"><div class="cui-skeleton__item" style="width: 60px; height: 20px;"></div></div>
                  <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
                </div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 20px;"></div></div>
              </div>

              <div style="display: flex; gap: 16px; justify-content: flex-end; margin-top: 8px;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>
          </div>
        </div>

        <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 160px; height: 18px;"></div></div>

      </div>
    </div>

  </div>

  <div class="display-block display-md-none">
    <div class="cui-row">
      <div class="cui-col-lg-12 cui-skeleton-paragraph -size--small -resolution--desktop -spacing--top-16 -spacing--bottom-40">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
    </div>

    <div class="cui-row -spacing--bottom-64">
      <div class="cui-col-sm-4">
        <div class="cui-skeleton-heading -size--large -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width:100%">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>

        <div class="display-flex -spacing--top-24 -spacing--bottom-24">
          <div class="cui-skeleton-rectangle -spacing--right-24" style="width: 100%;"><div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div></div>
          <div class="cui-skeleton-rectangle" style="width: 100%;"><div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div></div>
        </div>

        <div class="cui-skeleton-rectangle -spacing--top-24 -spacing--bottom-24" style="display: flex; justify-content: center;">
          <div class="cui-skeleton__item" style="width: 160px; height: 18px;"></div>
        </div>

        <div>
          <div class="catalog-product-multi-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
            
            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="display: flex; justify-content: center; margin-top: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
    
            <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
            </div>
            <div style="display: flex; gap: 16px; justify-content: flex-end;">
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>           
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
            
            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="display: flex; justify-content: center; margin-top: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
    
            <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
            </div>
            <div style="display: flex; gap: 16px; justify-content: flex-end;">
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>           
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
            
            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="display: flex; justify-content: center; margin-top: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
    
            <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
            </div>
            <div style="display: flex; gap: 16px; justify-content: flex-end;">
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>           
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
            
            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="display: flex; justify-content: center; margin-top: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
    
            <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
            </div>
            <div style="display: flex; gap: 16px; justify-content: flex-end;">
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>           
            </div>
          </div>

          <div class="catalog-product-multi-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
            
            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0; border-bottom: 1px solid #E8E8E8;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="padding: 16px 0;">
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 200px; height: 20px;"></div></div>
              <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

              <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
                <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
              </div>
              <div style="display: flex; gap: 16px; justify-content: flex-end;">
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>
                <div class="cui-skeleton-button -size--medium">
                  <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
                </div>           
              </div>
            </div>

            <div style="display: flex; justify-content: center; margin-top: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 100px; height: 20px;"></div></div>
            </div>
          </div>

          <div class="catalog-product-single-skeleton-sm" style="border: 1px solid #E8E8E8; padding: 24px; margin-bottom: 24px;">
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16"><div class="cui-skeleton__item" style="width: 120px; height: 120px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4"><div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8"><div class="cui-skeleton__item" style="width: 60px; height: 18px;"></div></div>

            <div class="cui-skeleton-paragraph -size--small -resolution--mobile -spacing--bottom-16">
              <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
              </div>
            </div>
    
            <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 170px; height: 18px;"></div></div>
              <div class="cui-skeleton-rectangle"><div class="cui-skeleton__item" style="width: 90px; height: 18px;"></div></div>
            </div>
            <div style="display: flex; gap: 16px; justify-content: flex-end;">
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 125px;"><div class="cui-skeleton__item cui-skeleton-button__button"></div></div>
              </div>           
            </div>
          </div>

        </div>

        <div style="display: flex; justify-content: center;">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 160px; height: 18px;"></div></div>
        </div>

    </div>
  </div>

</div>
`
};
